/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import { useNavigate } from 'react-router-dom'
import FreeAppModel from '../../FreeAppModel'
import Select from 'react-select'
import ViewModel from '../../ViewModal'
export default function DataTableData() {
  const AppService = useAppServices()
  const navigate = useNavigate()
  const [List, setList] = useState([])
  const [products, setproducts] = useState([])
  const [Categories, setCategories] = useState([])
  const [loader, setloader] = useState(true)

  const options = [
    { value: 'Planned', label: 'Planned' },
    { value: 'Inprogress', label: 'Inprogress' },
    { value: 'completed', label: 'completed' },
  ]
  const getApps = async () => {
    // alert('called')
    const { response, error } = await AppService.updateRequest.filter({
      query: 'request_type=new_app',
    })
    // return 0
    if (response) {
      setList(response.data)
      setloader(false)

      // setList(response.data)
    } else {
      setloader(false)
    }
  }
  const onLoad = () => {
    getApps()
  }
  const handleDelete = async (id) => {
    const { response } = await AppService.updateRequest.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  const handleClickUpTask = async (request) => {
    const payload = request
    // console.log(payload)
    const { response } = await AppService.updateRequest.create_task({
      payload: payload,
    })
    if (response) onLoad()
  }
  useEffect(onLoad, [])
  function formatDate(dateString) {
  const date = new Date(dateString);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  // Remove time for comparison
  const isToday = date.toDateString() === today.toDateString();
  const isYesterday = date.toDateString() === yesterday.toDateString();

  if (isToday) return 'Today';
  if (isYesterday) return 'Yesterday';

  // Format as "Jul 11, 2025"
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}
  return {
    loader: loader,
    products: products,
    Categories: Categories,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
          { Header: 'Date', accessor: 'createdAt' },
        
        { Header: 'path', accessor: 'path' },

        { Header: 'title', accessor: 'title' },
        { Header: 'company_id', accessor: 'company_id' },
        { Header: 'app_type', accessor: 'app_type' },
        { Header: 'type', accessor: 'type' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: List.map((data) => ({
        createdAt: formatDate(data.createdAt),
        title: data.title,
        path: data.path,
        app_name: data.app_name,
        company_id: data.company_id,
        app_type: data.app_type,
        type: data.type,
        action: (
          <MDBox>
            {data?.request_status === 'approved' ?
              <MDButton variant="contained" type='button' color="success" size="small">
                Approved
              </MDButton>
              :
              <ViewModel data={data} />
            }
          </MDBox>
        ),
      })),
    },
  }
}
